import PropTypes from 'prop-types'
import { useMemo, useState } from 'react'

import Button from '../button'
import DetailView from './components/detail-view'
import { EndorsementsEl } from './elements'

const Endorsements = ({ data }) => {
  const [showDetails, toggleShowDetails] = useState(null)

  const item = useMemo(
    () => (showDetails !== null ? data[showDetails] : null),
    [data, showDetails],
  )

  return (
    <EndorsementsEl>
      {data.map(({ logo, name, link }, index) => (
        <Button key={link} onClick={() => toggleShowDetails(index)}>
          <div className='logo'>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img key={logo} alt={name} src={logo} />
          </div>
        </Button>
      ))}

      {item && (
        <DetailView
          close={() => toggleShowDetails(null)}
          data={item}
          hideNavigation={data.length <= 1}
          next={() =>
            toggleShowDetails((old) => {
              if (old === null) {
                return null
              }

              return (old + 1) % data?.length
            })
          }
          previous={() =>
            toggleShowDetails((old) => {
              if (old === null) {
                return null
              }

              const final = old - 1

              if (final < 0) {
                return final + data?.length
              }
              return final
            })
          }
        />
      )}
    </EndorsementsEl>
  )
}

export default Endorsements

Endorsements.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      artistComment: PropTypes.string.isRequired,
      brandComment: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      logo: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
}
